import { Dropdown, message, Select } from "antd"
import React, { useEffect, useState } from "react"
import DropdownService from "src/services/DropdownService"

const SelectCarrier = ({
  value,
  onChange,
  disabled,
  countryId = null,
  style = { height: "36px" },
  isView,
}) => {
  const [carries, setCarries] = useState([])

  useEffect(() => {
    fetchCarrier()
  }, [countryId])
  const fetchCarrier = async () => {
    try {
      const response = await DropdownService.getListAllNetwork({
        country_id: countryId,
      })
      setCarries(response?.success || [])
    } catch (error) {
      console.error("Lỗi khi lấy danh sách nhà mạng", error)
      message.error("Không thể lấy danh sách nhà mạng")
    }
  }

  return (
    <Select
      placeholder="Chọn nhà mạng"
      title="Chọn nhà mạng"
      allowClear
      showSearch
      value={value}
      onChange={onChange}
      style={style}
      disabled={disabled}
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
      }
    >
      {carries.map(carrier => (
        <Select.Option key={carrier.ID} value={carrier.ID}>
          {carrier.name}
        </Select.Option>
      ))}
    </Select>
  )
}

export default SelectCarrier
